import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';

import { Theme } from '@app/theme';
import { useMe } from '@app/api';

interface Props {
  children: React.ReactElement;
}

const useStyles = createUseStyles((theme: Theme) => ({
  banner: {
    position: 'fixed',
    top: 0,
    right: 0,
    left: 0,
    zIndex: 10000000,

    margin: 'auto',
    maxWidth: theme.marginBase * 80,

    ...theme.fonts.caption,

    backgroundColor: theme.colors.redAccessible,
    color: theme.colors.white,
    textAlign: 'center',

    padding: `${theme.marginBase}px ${theme.marginBase * 2}px`,
    borderRadius: theme.borderRadius.std,
  },
}));

export const ConnectingAsGate = (props: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { data: account } = useMe(true);

  return (
    <React.Fragment>
      {account && account.loggedAsOther && (
        <div className={classes.banner}>
          Vous êtes connecté en tant que{' '}
          <strong>
            {account.firstName} {account.lastName}
          </strong>{' '}
          ({account.email})
        </div>
      )}
      {props.children}
    </React.Fragment>
  );
};
